import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../services/api";
import "./editschool.css";

export default function EditSchool() {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  const [form, setForm] = useState({
    name: "",
    address: "",
    contact_email: "",
    contact_phone: "",
    subdomain: "",
    custom_domain: "",
    max_students_allowed: "",
    academic_year: "",
    payment_mode: "",
    admin_username: "",
    admin_email: "",
    plan_expiry: "",   // ✅ Added expiry
  });

  // =============================
  // LOAD SCHOOL
  // =============================
  const loadSchool = async () => {
    try {
      const res = await API.get(`/schools/${id}/`);
      const s = res.data.school;

      setForm({
        name: s.name || "",
        address: s.address || "",
        contact_email: s.contact_email || "",
        contact_phone: s.contact_phone || "",
        subdomain: s.subdomain || "",
        custom_domain: s.custom_domain || "",
        max_students_allowed: s.max_students_allowed || "",
        academic_year: s.academic_year || "",
        payment_mode: s.payment_mode || "direct",
        admin_username: s.admin_username || "",
        admin_email: s.admin_email || "",
        plan_expiry: s.plan_expiry ? s.plan_expiry.split("T")[0] : "", // ✅ Fix date format
      });

      setLoading(false);
    } catch (err) {
      console.error("Load error:", err);
    }
  };

  useEffect(() => {
    loadSchool();
  }, []);

  // =============================
  // HANDLE CHANGE
  // =============================
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // =============================
  // SUBMIT UPDATE
  // =============================
  const handleSubmit = async () => {
    try {
      await API.put(`/schools/${id}/update/`, form);

      setMessage("School updated successfully!");

      setTimeout(() => {
        window.location.href = `/schools/${id}`;
      }, 800);
    } catch (err) {
      console.error(err);
      setMessage("Update failed");
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="edit-container">
      <h2>Edit School</h2>

      {message && <div className="alert-msg">{message}</div>}

      <div className="edit-card">

        {/* SCHOOL NAME */}
        <label>School Name</label>
        <input className="input" name="name" value={form.name} onChange={handleChange} />

        {/* ADDRESS */}
        <label>Address</label>
        <input className="input" name="address" value={form.address} onChange={handleChange} />

        {/* EMAIL */}
        <label>Contact Email</label>
        <input className="input" name="contact_email" value={form.contact_email} onChange={handleChange} />

        {/* PHONE */}
        <label>Contact Phone</label>
        <input className="input" name="contact_phone" value={form.contact_phone} onChange={handleChange} />

        {/* SUBDOMAIN */}
        <label>Subdomain</label>
        <input className="input" name="subdomain" value={form.subdomain} onChange={handleChange} />

        {/* CUSTOM DOMAIN */}
        <label>Custom Domain</label>
        <input className="input" name="custom_domain" value={form.custom_domain} onChange={handleChange} />

        {/* MAX STUDENTS */}
        <label>Max Students Allowed</label>
        <input className="input" name="max_students_allowed" value={form.max_students_allowed} onChange={handleChange} />

        {/* ACADEMIC YEAR */}
        <label>Academic Year</label>
        <input className="input" name="academic_year" value={form.academic_year} onChange={handleChange} />

        {/* PAYMENT MODE */}
        <label>Payment Mode</label>
        <select className="input" name="payment_mode" value={form.payment_mode} onChange={handleChange}>
          <option value="direct">Direct</option>
          <option value="partner">Partner</option>
        </select>

        {/* PLAN EXPIRY ✅ NEW */}
        <label>Plan Expiry Date</label>
        <input
          type="date"
          className="input"
          name="plan_expiry"
          value={form.plan_expiry}
          onChange={handleChange}
        />

        {/* ADMIN USERNAME */}
        <label>Admin Username</label>
        <input className="input" name="admin_username" value={form.admin_username} onChange={handleChange} />

        {/* ADMIN EMAIL */}
        <label>Admin Email</label>
        <input className="input" name="admin_email" value={form.admin_email} onChange={handleChange} />

        {/* SAVE BUTTON */}
        <button className="btn-save" onClick={handleSubmit}>
          Save Changes
        </button>
      </div>
    </div>
  );
}